import React, { Component } from 'react';
import GiftRegistryNewAddress from '../../../../../../createEvent/components/GiftRegistryNewAddress';
import CommonUtil from '../../../../../../../utils/commonUtil';
 

class AddAddressModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            address: '',
        };
    } 
    render() {
        return (
            <div>                 
                <GiftRegistryNewAddress
                            eventId={this.props.eventId}
                            celebrityName={this.props.celebrityName}
                            evevntManagement={true}
                            closeHandler = {this.props.closeHandler}
                        />
            </div>
        );
    }
}

export default AddAddressModal;